import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7437cfc5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437cfc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7437cfc5')) {
      api.createRecord('7437cfc5', component.options)
    } else {
      api.reload('7437cfc5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7437cfc5&scoped=true", function () {
      api.rerender('7437cfc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/terminal/index.vue"
export default component.exports